export const SocialProvider = {
  INSTAGRAM: 'INSTAGRAM',
  TIKTOK: 'TIKTOK',
} as const;

export type SocialProvider = (typeof SocialProvider)[keyof typeof SocialProvider];

export const PROVIDER_DISPLAY_NAME: Record<SocialProvider, string> = {
  INSTAGRAM: 'Instagram',
  TIKTOK: 'TikTok',
};
